/**
 * @descripton Displays the results of the personnel sync operation as totals
 */

import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import { SyncResultsContext } from '../contexts/SyncResults';

const styles = {
  count: {
    fontSize: '24px'
  },
  countContainer: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    minHeight: '100px',
    minWidth: '200px',
    p: 2
  },
  countType: {
    fontSize: '20px'
  },
  listContainer: {
    display: 'flex',
    gap: 3,
    justifyContent: 'center',
    width: '100%'
  }
};

const CountList = () => {
  const results = React.useContext(SyncResultsContext) ?? {};

  // Prepare the list of results to display
  const list = React.useMemo(() => [
    {
      color: 'success.main',
      count: results.successfulSyncs ?? 0,
      title: 'Successful Syncs'
    },
    {
      color: 'text.secondary',
      count: results.partialSyncs ?? 0,
      title: 'Partial Syncs'
    },
    {
      color: 'warning.main',
      count: results.unmappedHeaders?.length ?? 0,
      title: 'Unmapped Values'
    },
    {
      color: 'error.main',
      count: results.failedSyncs ?? 0,
      title: 'Failed Syncs'
    }
  ], [results]);

  return (
    <Box sx={styles.listContainer}>
      {list.map(({ color, count, title }) => (
        <Paper key={title} sx={styles.countContainer}>
          <Typography sx={{ ...styles.countType, color }}>{title}</Typography>
          <Typography sx={{ ...styles.count, color }}>{count}</Typography>
        </Paper>
      ))}
    </Box>
  )
};

export default CountList;
